import { TranslationKey } from './../../../../types/translation/TranslationKey';
import React from 'react';
import { TagRelation } from '../../../../types/tag/tagRelation';
import { EntityType } from '../../../../types/comment';
import { t } from '../../../../types/translation/Translator';
import { LocationMarkerIcon } from '../../../icons/LocationMarker/LocationMarkerIcon';
import { toFilterString } from '../../../../util/string.util';
import { BaseFilter, BaseFilterProps } from '../common/BaseFilter';
import { FilterProps, FilterStorageKey } from '../common/filter.util';
import { TagFilter } from '../TagFilter';
import { StockLocationRoleAssignment } from '../../../../types/stock_location_role_assignment/stockLocationRoleAssignment';
import { StockLocationFilter } from '../StockLocationFilter';
import { StockLocation } from '../../../../types/stock_location/stockLocation';
import { Company } from '../../../../types/company';

export class StockLocationRoleAssignmentFilter extends BaseFilter<StockLocationRoleAssignment> {
  tagRelations: Map<string, TagRelation>;
  stockLocations: Map<string, StockLocation>;
  company: Company;

  constructor(tagRelations: Map<string, TagRelation>, stockLocations: Map<string, StockLocation>, company: Company) {
    super(FilterStorageKey.STOCK_LOCATION);
    this.tagRelations = tagRelations;
    this.stockLocations = stockLocations;
    this.company = company;
  }

  filterOptions(): BaseFilter<any>[] {
    return [new TagFilter(EntityType.stockLocation)];
  }

  toLabel(): string {
    return t(TranslationKey.stockLocation).singular.label;
  }

  toCount(props: BaseFilterProps): number {
    return 0;
  }

  toIcon(): JSX.Element {
    return <LocationMarkerIcon className={this.className} />;
  }

  toDropdownContent(props: BaseFilterProps): JSX.Element {
    return <></>;
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return <></>;
  }

  search(item: StockLocationRoleAssignment, query: string) {
    if (toFilterString(item.role).includes(query)) return true;

    const stockLocation = this.stockLocations.get(item.stockLocationId);
    if (stockLocation) {
      const stockLocationFilter = new StockLocationFilter(this.tagRelations, this.company);
      if (stockLocationFilter.search(stockLocation, query)) return true;
    }

    return false;
  }

  filteredItems(items: StockLocationRoleAssignment[], query: string, filterProps: FilterProps) {
    const filteredStockLocations = TagFilter.filter(this.tagRelations, EntityType.stockLocation, filterProps);

    if (this.tagRelations && filteredStockLocations.size === 0 && filterProps.stockLocation?.size) return [];

    const result = items.filter(item => {
      if (filteredStockLocations.size && !filteredStockLocations.has(item.id)) {
        return false;
      }

      return this.search(item, query);
    });

    return result;
  }
}
